import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import { DISCLOSURES_TEXT } from '#client/constants/text';

import PageWrapper from './PageWrapper';

export default function Footer() {
  return (
    <PageWrapper>
      <Box margin="auto">
        <Text
          align="left"
          color="tertiary"
          size="xs"
        >
          {DISCLOSURES_TEXT}
        </Text>
      </Box>
    </PageWrapper>
  );
}
